import React, { useEffect, useState } from "react";
import { api, fmtDate } from "../lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { useNavigate } from "react-router-dom";

export default function B2CEnrollment() {
  const [rows, setRows] = useState([]);
  const [meta, setMeta] = useState(null);
  const [filters, setFilters] = useState({});
  const nav = useNavigate();
  const load = async () => {
    const qs = new URLSearchParams(Object.entries(filters).filter(([_,v]) => v && v !== "all"));
    const [r, m] = await Promise.all([api.get(`/b2c/enrollment-semesters?${qs}`), api.get("/b2c/meta")]);
    setRows(r.data); setMeta(m.data);
  };
  useEffect(() => { load(); }, [filters]); // eslint-disable-line
  if (!meta) return <div>Loading…</div>;
  const officers = meta.users.filter(u => ["admissions_officer","admin","manager"].includes(u.role));

  return (
    <div className="space-y-6">
      <div><h1 className="heading-font text-3xl font-bold text-slate-900">B2C Enrollment</h1><p className="text-sm text-slate-500 mt-1">Semester-level enrollment across all applications.</p></div>
      <div className="bg-white p-3 rounded-xl border border-slate-200 flex flex-wrap gap-2 items-center">
        <Select value={filters.status||"all"} onValueChange={v=>setFilters({...filters, status:v})}>
          <SelectTrigger className="w-56 h-9 bg-white" data-testid="b2c-enr-status"><SelectValue placeholder="Status"/></SelectTrigger>
          <SelectContent><SelectItem value="all">All Statuses</SelectItem>{["PENDING","ENROLLED","DEFERRED","WITHDRAWN"].map(s=><SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
        </Select>
        <Select value={String(filters.semester_number||"all")} onValueChange={v=>setFilters({...filters, semester_number: v==="all"?"":Number(v)})}>
          <SelectTrigger className="w-44 h-9 bg-white"><SelectValue placeholder="Semester"/></SelectTrigger>
          <SelectContent><SelectItem value="all">All Semesters</SelectItem>{[1,2,3,4].map(n=><SelectItem key={n} value={String(n)}>Semester {n}</SelectItem>)}</SelectContent>
        </Select>
        <Select value={filters.college_id||"all"} onValueChange={v=>setFilters({...filters, college_id:v})}>
          <SelectTrigger className="w-56 h-9 bg-white" data-testid="b2c-enr-college"><SelectValue placeholder="College"/></SelectTrigger>
          <SelectContent><SelectItem value="all">All Colleges</SelectItem>{meta.colleges.map(c=><SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>)}</SelectContent>
        </Select>
        <Select value={filters.intake_id||"all"} onValueChange={v=>setFilters({...filters, intake_id:v})}>
          <SelectTrigger className="w-44 h-9 bg-white" data-testid="b2c-enr-intake"><SelectValue placeholder="Intake"/></SelectTrigger>
          <SelectContent><SelectItem value="all">All Intakes</SelectItem>{meta.intakes.map(i=><SelectItem key={i.id} value={i.id}>{i.name}</SelectItem>)}</SelectContent>
        </Select>
        <Select value={filters.admission_officer_id||"all"} onValueChange={v=>setFilters({...filters, admission_officer_id:v})}>
          <SelectTrigger className="w-56 h-9 bg-white" data-testid="b2c-enr-officer"><SelectValue placeholder="Admission Officer"/></SelectTrigger>
          <SelectContent><SelectItem value="all">All Officers</SelectItem>{officers.map(u=><SelectItem key={u.user_id} value={u.user_id}>{u.name}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-xs uppercase tracking-wide text-slate-500"><tr><th className="text-left px-4 py-3">Student</th><th className="text-left px-4 py-3">College</th><th className="text-left px-4 py-3">Intake</th><th className="text-left px-4 py-3">Officer</th><th className="text-left px-4 py-3">Semester</th><th className="text-left px-4 py-3">Status</th><th className="text-left px-4 py-3">Confirmation</th></tr></thead>
          <tbody>
            {rows.map(r=>(
              <tr key={r.id} onClick={()=>nav(`/b2c/applications/${r.application_id}`)} className="border-t border-slate-100 hover:bg-slate-50 cursor-pointer">
                <td className="px-4 py-3 font-medium">{r.student?.full_name}</td>
                <td className="px-4 py-3">{r.college?.name}</td>
                <td className="px-4 py-3">{r.current_intake?.name}</td>
                <td className="px-4 py-3 text-xs">{r.admission_officer?.name || "—"}</td>
                <td className="px-4 py-3">Semester {r.semester_number}</td>
                <td className="px-4 py-3"><span className={`stage-badge ${r.status==="ENROLLED"?"bg-emerald-50 text-emerald-900 border-emerald-300":r.status==="DEFERRED"?"bg-amber-50 text-amber-900 border-amber-300":r.status==="WITHDRAWN"?"bg-red-50 text-red-900 border-red-300":"bg-slate-50 text-slate-800 border-slate-300"}`}>{r.status}</span></td>
                <td className="px-4 py-3 text-xs">{fmtDate(r.enrollment_confirmation_date)}</td>
              </tr>
            ))}
            {rows.length===0 && <tr><td colSpan={7} className="text-center py-10 text-slate-500">No enrollment records match.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
